<template>
  <div id="contenedor-contrato-directorio-tool-bar">
    <v-toolbar flat color="transparent">
      <v-spacer></v-spacer>
      <custom-button
        v-if="mixValidaScopesActions(1)"
        label="Nuevo"
        iconText="mdi-plus"
        tipo="agregar"
        @click="nuevoDirectorio">
      </custom-button>
    </v-toolbar>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ContratoDirectorioToolBar',
  components: {
    CustomButton,
  },
  data() {
    return {};
  },
  methods: {
    nuevoDirectorio() {
      this.$emit('nuevoDirectorio');
    },
  },
};
</script>

<style lang="scss">

</style>
